import { render, staticRenderFns } from "./price-view-page.vue?vue&type=template&id=ec0b1656&"
import script from "./price-view-page.vue?vue&type=script&lang=js&"
export * from "./price-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports